import { size } from "polished";
import styled from "styled-components";
import SystemHeadshot from "~/shared/components/svg/system-headshot.svg?react";

/**
 * Get initials from first/last name of user
 *
 * @param {string[]} text
 */
const getInitials = (text: string[] | null) => {
  if (!text) return;

  return text
    .map((string) => typeof string === "string" && string.charAt(0))
    .join("")
    .toUpperCase();
};

const CircleImgRoot = styled.div`
  border-radius: 50%;
  overflow: hidden;
  ${size("var(--avatar-override-size, var(--size))")}
`;

const FallbackCircle = styled.div`
  ${size("var(--avatar-override-size, var(--size))")}
  background-color: var(--fallback-bg-color, var(--light-green));
  color: var(--fallback-text-color, var(--color-ds-text-primary));
  border-radius: 50%;
  line-height: var(--size);
  text-align: center;
  font-weight: 500;
  letter-spacing: 0.075em;
  font-size: var(--font-size);
`;

export const SystemAvatar = styled(SystemHeadshot)`
  ${size("var(--avatar-override-size, var(--size))")}
`;

interface AvatarProps {
  size: number;
  src: string | null;
  fallback?: string[];
  fallbackFontSize?: number;
  style?: React.CSSProperties;
}

const Avatar = ({ size, src, fallback, fallbackFontSize, style, ...rest }: AvatarProps) => {
  if (!src && fallback && fallback[0]) {
    return (
      <FallbackCircle
        style={
          {
            ...style,
            "--size": `${size}px`,
            "--font-size": `${fallbackFontSize || 16}px`,
          } as React.CSSProperties
        }
        {...rest}
      >
        {getInitials(fallback)}
      </FallbackCircle>
    );
  } else if (src) {
    return (
      <CircleImgRoot {...rest} style={{ "--size": `${size}px`, ...style } as React.CSSProperties}>
        <img src={src} alt="" className="size-full object-cover" />
      </CircleImgRoot>
    );
  }

  return <SystemAvatar {...rest} style={{ "--size": `${size}px`, ...style } as React.CSSProperties} />;
};

export default Avatar;
